import * as pkg from "./../package.json";
import { createApp } from "vue";
import App from "./App.vue";

//
const app = createApp(App);

//
const packageJson = pkg;
const { name } = packageJson;
const containerElement = document.querySelector(`#${name}`);
app.provide("containerElement", containerElement);
app.mount(containerElement);
